import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface NewUserState {
    firstName: string
    lastName: string
    middleName: string,
    email:string,
    cellPhone: string
    code: string,
    userId: string,
    password: string,
    confirmPassword: string
    privacyStatement: boolean
}

const initialState: NewUserState = {
    firstName: '',
    lastName: '',
    middleName: '',
    email: '',
    cellPhone: '',
    code: '',
    userId: '',
    password: '',
    confirmPassword: '',
    privacyStatement: false

};

export const newUserSlice = createSlice({
    name: 'newuser',
    initialState,
    reducers: {
        setNewUser(state, action: PayloadAction<NewUserState>) {
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.middleName = action.payload.middleName;
            state.email = action.payload.email;
            state.cellPhone = action.payload.cellPhone;
            state.code = action.payload.code;
            state.userId = action.payload.userId;
            state.password = action.payload.password;
            state.confirmPassword = action.payload.confirmPassword;
            state.privacyStatement = action.payload.privacyStatement;
        },
    },
});

export const newUserActions = newUserSlice.actions;
export type newUserSlice = {
    [newUserSlice.name]: ReturnType<typeof newUserSlice['reducer']>
};